module.exports = __webpack_public_path__ + "img/9791185093000.3ebafe16.jpg";